// src/components/CrmDialog.js
import React from "react";
import { Dialog } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

/**
 * CrmDialog
 *
 * A global CRM-standard modal with:
 * - 16px rounded corners
 * - Glass / blurred panel
 * - Soft shadow
 * - Responsive padding
 * - Full light/dark mode support
 *
 * Usage:
 * <CrmDialog open={open} onClose={handleClose}>
 *    ...modal content...
 * </CrmDialog>
 */

export default function CrmDialog({
  children,
  PaperProps,
  ...props
}) {
  const theme = useTheme();

  // Theme-aware glass background
  const glassBg =
    theme.palette.mode === "dark"
      ? "rgba(20,20,30,0.85)"
      : "rgba(255,255,255,0.92)";

  return (
    <Dialog
      {...props}
      PaperProps={{
        ...PaperProps,
        sx: {
          borderRadius: "16px",
          backdropFilter: "blur(12px)",
          backgroundColor: glassBg,
          boxShadow: "0 8px 32px rgba(0,0,0,0.20)",
          p: 2,
          // Allow any per-dialog overrides, but they can't break structure
          ...PaperProps?.sx,
        },
      }}
    >
      {children}
    </Dialog>
  );
}
